import { ActiveChannelRequest } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const getPresetChannelsByIdQueryKey = (presetId: string) => [QUERY_KEYS.getPresetChannelsById, presetId];

const getPresetActiveChannels = async (presetId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offer-presets/${presetId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetPresetActiveChannels = ({ presetId = '', enabled }: { presetId?: string; enabled: boolean }) => {
  return useGenericQuery<ActiveChannelRequest, RequestError>(
    [QUERY_KEYS.getPresetChannelsById, presetId],
    () => getPresetActiveChannels(presetId),
    {
      enabled,
    }
  );
};
